import React, { useState, useEffect } from 'react'
import Invest from '../../Assets/images/sav.png'
import Skeleton from '@mui/material/Skeleton'
import Line from '../../Assets/images/Line.png'
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import ButtonPlus from '../SelectValue/ButtonPlus';
import getServices from '../../Services/get-service';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Constant from '../../Constant'
function Topsec() {
  const [show, setShow] = useState(false)
  const [savingsBalance, setSavingsBalance] = useState(0)
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    setLoading(true)
    getServices.userGetSavingsWalletBalance().then(
      (response) => {
        setLoading(false)
        if (response.data.statusCode === 200) {
          const data = response.data.data;
          const totalSavings = data.totalSavingsBalance;
          setSavingsBalance(totalSavings);
        }
      },
      (error) => {
        setLoading(false)
        toast.error(error.response?.data?.description, { autoClose: 1000 });
      }
    );
  }, [])

  return (
    <>
      <div className=' my-4 border rounded-md p-5 border-[#E6E6E7] md:flex gap-3'>
        <div className=' flex gap-3'>
          <div>
            <img src={Invest} alt='Invest' />
          </div>
          <div onClick={() => setShow(!show)}>
            <p className=' text-back-color2 text-[14px] mb-1'>Savings  balance <span className=' pl-2 text-[#808285]'>{show ? <VisibilityOffOutlinedIcon /> : <VisibilityOutlinedIcon />}</span></p>
            <div className=' text-2xl text-back-color2'>
              {loading ? <Skeleton variant="text" width={120} height={40} /> : (show ? '*******' : `${savingsBalance === 'nu' ? '₦ 0.0' : `₦ ${Constant.FormatNumber(savingsBalance)}`}`)}
            </div>
          </div>
        </div>
        {/* <div className=' pt-2'>
        <img src={Line} className=' hidden md:block' alt='Line'/>
        </div> */}
        {/* <div className=' pt-2'>
        <a href='#plans'>
        <ButtonPlus
                name='Fund a plan'
            />
        </a>
           
        </div> */}
      </div>
    </>

  )
}

export default Topsec